import Select from 'react-select'
import { useTheme } from '../../context/ThemeContext'
import { useAuth } from '../../modules/auth'
// import { useAuth } from '../../../app/modules/auth'

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const AssignTo = ({ options, setSelected, selected, role, page, isHome }: any) => {
  const { theme: themeDark } = useTheme()
  const { currentUser } = useAuth()
  const { fullName } = currentUser?.data.user

  const colourStyles: any = {
    option: (styles: any, { isFocused, isSelected }: any) => ({
      ...styles,
      backgroundColor: isHome ? isSelected
        ? '#009ef7'
        : isFocused
          ? themeDark === 'dark' ? '#2a2a2a' : '#f0f0f0'
          : 'transparent' : styles.backgroundColor,
      color: isHome ? isSelected
        ? 'white'
        : themeDark === 'dark'
          ? 'white'
          : 'black' : styles.color,
    }),

    control: (styles: any, state: any) => ({
      ...styles,
      backgroundColor:
        isHome
          ? (themeDark === 'dark' ? '' : '') : (themeDark === 'dark' ? '' : 'white'),
      borderColor:
        state?.isFocused ? '#d4f746' : 'hsl(0, 0%, 80%)',
      boxShadow: (state?.isFocused ? '0 0 0 1px #d4f746' : 'none'),
      '&:hover': {
        borderColor: '#d4f746',
      },
    }),
    multiValue: (styles: any) => {
      return {
        ...styles,
        backgroundColor: themeDark === 'dark' ? '#141520' : '#E6E6E6',
        color: isHome
          ? themeDark === 'dark' ? 'white' : 'black' : styles.color
      }
    },
    indicatorSeparator: (styles: any) => ({
      ...styles,
      backgroundColor: isHome ? '' : styles.backgroundColor,
    }),
    multiValueLabel: (styles: any, { data }: any) => ({
      ...styles,
      backgroundColor: data.isDisabled ? '#FF677E' : '',
      color: data.isDisabled ? 'white' : '',
    }),
    multiValueRemove: (styles: any, { data }: any) => ({
      ...styles,
      color: data.color,
      ':hover': {
        backgroundColor: '#FF677E',
        color: 'white',
      },
    }),
    valueContainer: (styles: any) => ({
      ...styles,
      overflow: 'auto',
      minHeight: page ? '' : '100px',
      alignItems: 'flex-start',
      height: page ? '100px' : '38px',
      maxHeight: page ? '100px' : '150px',
    }),
    dropdownIndicator: (styles: any) => ({
      ...styles,
      color: themeDark === 'dark' ? '#FF7C00' : 'hsl(0, 0%, 80%)',
    }),
    placeholder: (styles: any) => ({
      ...styles,
      color: themeDark === 'dark' ? '#98C6F0' : 'hsl(0, 0%, 80%)',
    }),
  }
  return (
    <>
      <Select
        isDisabled={role === 'Guest'}
        value={selected}
        isMulti
        options={options}
        className='basic-multi-select'
        classNamePrefix='select'
        styles={colourStyles}
        onChange={(e: any) => {
          if (page) {
            const adminItems = selected.filter((item: any) => item.isOwner || item.label.toLowerCase() === fullName.toLowerCase());
            const nonAdminItems = e.filter((item: any) => !item.isOwner);
            setSelected([...adminItems, ...nonAdminItems]);
          } else {
            setSelected(e);
          }
        }}
        theme={(theme) => ({
          ...theme,

          colors: {
            ...theme.colors,

            neutral0: themeDark === 'dark' ? '#1d1e2c' : theme.colors.neutral0,
            neutral80: themeDark === 'dark' ? '#F4FFFD' : theme.colors.neutral80,
            primary25: themeDark === 'dark' ? '#141520' : theme.colors.primary25,
          },
        })}
      />
    </>
  )
}
export default AssignTo
